import { createRequestDataSource } from '@ngneat/elf-requests';
import { select } from '@ngneat/elf';
import {suppliersUnitsDetailsStore} from '@store/suppliers/units/details/suppliers-units-details.store';
import {SuppliersUnit} from '@store/suppliers/units';

export const getSupplierUnitDetailsDataSource = createRequestDataSource({
  store: suppliersUnitsDetailsStore,
  data$: () => suppliersUnitsDetailsStore.pipe(select((state) => state as SuppliersUnit)),
  requestKey: 'getSupplierUnitDetails',
  dataKey: 'headOffice',
});
